export const steps = {
  bankAccountStep: 'bankAccountStep',
  verifyAccountStep: 'verifyAccountStep',
}
